// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__233OJ"};